import { useAuth0 } from "@auth0/auth0-react";
import axios from "axios";
import { useSetRecoilState } from "recoil";
import { getFullAccessModalOpenStatus } from "../atoms/rootAtom";
import { setSsePermissionHandler } from "../utils/sseFetch";

export function useInterceptor() {
	const { getAccessTokenSilently, loginWithRedirect } = useAuth0();
	const setGetFullAccessModalOpen = useSetRecoilState(getFullAccessModalOpenStatus);

	async function set() {
		// 设置SSE权限处理器
		setSsePermissionHandler(setGetFullAccessModalOpen);
		
		axios.interceptors.request.clear();
		axios.interceptors.request.use(
			async (config) => {
				try {
					const token = await getAccessTokenSilently();
					if (token) {
						config.headers["Authorization"] = "Bearer " + token;
					}
				} catch (error) {
					console.error("Error getting access token:", error);
					await loginWithRedirect();
				}

				return config;
			},
			(error) => {
				return Promise.reject(error);
			}
		);

		// 添加响应拦截器处理全局权限检查
		axios.interceptors.response.clear();
		axios.interceptors.response.use(
			(response) => {
				// 成功响应直接返回
				return response;
			},
			(error) => {
				// 检查错误响应中的action_required字段
				const action_required = error?.response?.data?.action_required;
				
				if (action_required === 'start_trial_or_upgrade' || action_required === 'upgrade') {
					// 检查当前路由是否为编辑页面
					const currentPath = window.location.pathname;
					const isEditPage = currentPath === '/edit' || currentPath.startsWith('/edit/');

					// 只在编辑页面触发全局权限弹框
					if (isEditPage) {
						setGetFullAccessModalOpen(true);
					}

					error.isPermissionError = true
				}
				
				// 继续抛出错误，让具体的业务逻辑处理
				return Promise.reject(error);
			}
		);
	}

	return set;
}
